import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import * as moment from 'moment';

@Component({
  selector: 'app-list-order',
  templateUrl: './list-order.component.html',
  styleUrls: ['./list-order.component.scss']
})
export class ListOrderComponent implements OnInit {

  orders=[]

  moment: any = moment;


  constructor(private router :Router,     
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    ) { }

  ngOnInit() {
    this.getAllStates();
  }


  getAllStates() {
    this.apiService.get(this.apiConfig.getAllOrders).subscribe(
      (res: any) => {
        this.orders = res.data;
        console.log(this.orders)
      },
      (err) => {
        console.log(err);
      }
    );
  }

  orderDetails()
  {
    this.router.navigateByUrl('/hubAdmin/details-order');
  }

}
